import axios from "axios";

export const createTrainingPackage = async (username, trainingPackageVO) => {
    try {
        const {data} = await axios.post("/api/trainingPackage/create", {username, trainingPackageVO});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveAllTrainingPackages = async (username) => {
    try {
        const {data} = await axios.get("/api/trainingPackage/viewAll?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveTrainingPackage = async (username, trainingPackageExternalReference) => {
    try {
        const {data} = await axios.post("/api/trainingPackage/view", {username, trainingPackageExternalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateTrainingPackage = async (username, trainingPackageVOToUpdate) => {
    try {
        const {data} = await axios.put("/api/trainingPackage/update", {username, trainingPackageVOToUpdate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const deleteTrainingPackage = async (username, externalReference) => {
    try {
        const {data} = await axios.delete("/api/trainingPackage/delete", {data: {username, externalReference}})
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const createTrainingGroup = async (username, trainingGroupVO) => {
    try {
        const {data} = await axios.post("/api/trainingGroup/create", {username, trainingGroupVO});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveAllTrainingGroups = async (username) => {
    try {
        const {data} = await axios.get("/api/trainingGroup/viewAll?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveTrainingGroup = async (username, externalReference) => {
    try {
        const {data} = await axios.post("/api/trainingGroup/view", {username, externalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateTrainingGroup = async (username, trainingGroupVO) => {
    try {
        const {data} = await axios.put("/api/trainingGroup/update", {username, trainingGroupVO});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const deleteTrainingGroup = async (username, externalReference) => {
    try {
        const {data} = await axios.delete("/api/trainingGroup/delete", {data: {username, externalReference}})
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
